// Bileli · shared/auth — reset the account-scoped Bileli stores on logout / identity switch.
//
// why: these zustand singletons live OUTSIDE Teact's `global`, so Telegram's own signOut/reset never
// touches them — a new account would otherwise keep seeing the previous account's cached workspace,
// spaces and live sessions. `setState(next, true)` REPLACES (zustand/vanilla) rather than merging, and
// bypasses any guard the store's own setter has (e.g. activeOrgStore refuses to clear to empty).

import { myLiveStore } from '../../modules/live/model/myLive.store';
import { activeOrgStore } from '../../modules/orgs/model/activeOrg.store';
import { pendingInviteStore } from '../../modules/orgs/model/pendingInvite.store';
import { directoryStore, drainStore } from '../../modules/spaces/store/drainStore';

/** Reset every account-scoped in-memory Bileli store to its initial state. */
export function clearBileliStores(): void {
  activeOrgStore.setState({ org: undefined }, true); // the workspace shown in the header — the visible one
  pendingInviteStore.setState({ token: undefined }, true);
  drainStore.setState({ status: 'idle', items: [] }, true);
  directoryStore.setState({ spaces: {} }, true);
  myLiveStore.setState({ sessions: [], fetchedAt: 0 }, true);
  // NOTE (residual, follow-up): the media upload stores + callDock are session-transient and clear
  // naturally; the spaces localStorage directory (recordSpace) is per-account persisted and is NOT wiped
  // here — a rarer «Сообщества» staleness that heals on the next drain read. Not chased this round.
}
